<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from "./components/popup"
import { mapState } from "vuex"
import { vConsoleWidget } from "@/utils/index"
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(["loading"])
  },
  created() {
    const { vc } = this.$route.query
    if (vc === "true") vConsoleWidget()
  }
}
</script>

<style lang="less">
@import "./assets/css/font.css";
// 输出 theme.less 中的 :root CSS 变量（供动态主题与 var() 引用）
@import "./assets/css/theme.less";
@import "./assets/css/public.less";
// 对齐 App：页面背景 ColorStyle.pageBackgroundColor(#FFFFFF)，主文字黑色
body {
  background: var(--page-bg);
  padding: 0;
  margin: 0;
  height: 100vh;
  color: var(--text-main);
}
#app {
  font-size: 28px;
}
// 对齐 App DecorStyle.btnPrimary：主题色背景 + 圆角 12~14 + Montserrat-M 粗体
.btn {
  height: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: @font-medium;
  font-size: 32px;
  font-weight: bold;
  border-radius: @radius-btn;
  border: none;
  padding: 0 40px;
  color: var(--text-white);
  background: var(--theme-color);
}
.downloadAppBox {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 10px #636363;
  z-index: 1;
  &-cancel {
    padding: 20px;
    display: flex;
    align-items: center;

    img {
      width: 100%;
      margin: 0 20px;
      border-radius: 10px;
    }
  }
  &-btn {
    padding: 0 20px;
    margin-right: 20px;
  }
}
</style>
